import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Liquidato } from '../../../models/liquidato';
import { SezioneEconomica } from '../../../models/sezioni/sezione-economica';
import { SezioneEconomicaLiquidatiAddComponent } from './sezione-economica-liquidati-add.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [sezione-economica-mod-liquidati-add]',
  templateUrl: 'sezione-economica-mod-liquidati-add.component.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SezioneEconomicaLiquidatiModAddComponent {
  @Output() onReturn: EventEmitter<SezioneEconomica> = new EventEmitter<SezioneEconomica>();
  @ViewChild('formLiquidatiAdd') formLiquidati: SezioneEconomicaLiquidatiAddComponent;

  inizializza(sezione: SezioneEconomica, liquidato: Liquidato, fascicolo: FascicoloFull, urlUpdate: string, isViewTerzoPignorato: boolean, idSezioneEsiti: string, urlReadSezioneEsiti: string) {
    this.formLiquidati.inizializza(sezione, liquidato, fascicolo, urlUpdate, isViewTerzoPignorato, idSezioneEsiti, urlReadSezioneEsiti);
    openModal('modaleLiquidatiAdd');
  }

  createForm() {
    this.formLiquidati.createForm();
  }

  manageModal() {
      closeModal('modaleLiquidatiAdd');
      this.onReturn.emit();
  }
}
